import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import { getServerNameCode } from '../../config/gcs/gcsConfigs';
import { CenterOpenState } from '../../types/gcs/center';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';

interface ConfirmCloseServiceDialogProps {
  gcsId: string;
  onClose: () => void;
}

function ConfirmCloseServiceDialog({ gcsId, onClose }: ConfirmCloseServiceDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [submitAction, setSubmitAction] = useState<AsyncAction>(AsyncAction.initial());
  const setCenterOpenState = useGcsStore((state) => state.setCenterOpenState);
  const nameCode = getServerNameCode(gcsId);

  const onConfirmClicked = async () => {
    try {
      setSubmitAction(AsyncAction.loading());
      await setCenterOpenState(gcsId, CenterOpenState.CENTER_OPEN_SERVICE_CLOSED);
      setSubmitAction(AsyncAction.success());
      onClose();
    } catch (error) {
      setSubmitAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmCloseServiceDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmCloseServiceDialog.confirmCloseServiceButton,
        callback: onConfirmClicked,
        isLoading: submitAction.isLoading
      }}
      errorText={submitAction.isFailure ? getLocalizedErrorMessage(submitAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmCloseServiceDialog.body.replace('{nameCode}', nameCode)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmCloseServiceDialog;
